import React from 'react';

import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import staticURL from 'lib/staticURL';

import BaseJoinTypeCardGrid from './BaseJoinTypeCardGrid';

export type CombineTablesMethod = PipelineStepType.JOIN | PipelineStepType.UNION_DATASETS;

const COMBINE_METHOD_ORDERED = [PipelineStepType.JOIN, PipelineStepType.UNION_DATASETS] as const;

const COMBINE_METHOD_TO_IMAGE = {
  [PipelineStepType.JOIN]: staticURL('/static/img/analysis-tool/join.svg'),
  [PipelineStepType.UNION_DATASETS]: staticURL('/static/img/analysis-tool/union.svg'),
} as const;

const COMBINE_METHOD_TO_TITLE = {
  [PipelineStepType.JOIN]: 'Join',
  [PipelineStepType.UNION_DATASETS]: 'Union',
} as const;

const COMBINE_METHOD_TO_DESCRIPTION = {
  [PipelineStepType.JOIN]: 'Combine tables horizontally, merging rows',
  [PipelineStepType.UNION_DATASETS]: 'Combine tables vertically, merging columns',
} as const;

interface CombineTablesMethodSelectorProps {
  combineTablesMethod: CombineTablesMethod | null;
  onSelectCombineTablesMethod: (combineTablesMethod: CombineTablesMethod) => void;
}

export default function CombineTablesMethodSelector({
  combineTablesMethod,
  onSelectCombineTablesMethod,
}: CombineTablesMethodSelectorProps): JSX.Element {
  return (
    <BaseJoinTypeCardGrid
      value={combineTablesMethod}
      onSelect={onSelectCombineTablesMethod}
      orderedValues={COMBINE_METHOD_ORDERED}
      valueToTitle={COMBINE_METHOD_TO_TITLE}
      valueToDescription={COMBINE_METHOD_TO_DESCRIPTION}
      valueToImageUrl={COMBINE_METHOD_TO_IMAGE}
    />
  );
}
